import React from 'react';
import PropTypes from 'prop-types';

function Star(props) {
  const {
    color,
    size,
  } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 36 36">
      <path
        fill={color}
        fillRule="evenodd"
        d="M18 0l-5.118 12.495L0 13.752l9.72 8.978L6.875 36 18 29.057 29.125 36 26.28 22.73 36 13.752l-12.883-1.257z"
      />
    </svg>
  );
}

Star.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};

export default Star;



// WEBPACK FOOTER //
// ./src/components/icons/Star.js